export const MIN_ZOOM_LEVEL = 2.5;
